/**
 * @generated SignedSource<<7fc5a32c065d677a503310576166ec0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubIssuesList$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddSubIssueButtonGroup" | "SubIssuesListView">;
  readonly " $fragmentType": "SubIssuesList";
};
export type SubIssuesList$key = {
  readonly " $data"?: SubIssuesList$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssuesList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubIssuesList",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubIssuesListView"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddSubIssueButtonGroup"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "2de94375213e61abebc72f007d73f08e";

export default node;
